import * as turf from '@turf/turf'

export const graden2amersfoort = (lat, lon) => {
    // WGS graden naar amersfoortcoordinaten in meters 
    var amersfoort = []
    var dF = 0.36 * (lat - 52.1551744);
    var dL = 0.36 * (lon - 5.38720621);
    var SomX = (190094.945 * dL) + (-11832.228 * dF * dL) + (-144.221 * Math.pow(dF, 2) * dL) + (-32.391 * Math.pow(dL, 3)) + (-0.705 * dF) + (-2.34 * Math.pow(dF, 3) * dL) + (-0.608 * dF * Math.pow(dL, 3)) + (-0.008 * Math.pow(dL, 2)) + (0.148 * Math.pow(dF, 2) * Math.pow(dL, 3));
    var SomY = (309056.544 * dF) + (3638.893 * Math.pow(dL, 2)) + (73.077 * Math.pow(dF, 2)) + (-157.984 * dF * Math.pow(dL, 2)) + (59.788 * Math.pow(dF, 3)) + (0.433 * dL) + (-6.439 * Math.pow(dF, 2) * Math.pow(dL, 2)) + (-0.032 * dF * dL) + (0.092 * Math.pow(dL, 4)) + (-0.054 * dF * Math.pow(dL, 4));
    amersfoort.push(Math.trunc(155000 + SomX));
    amersfoort.push(Math.trunc(463000 + SomY));
    return (amersfoort);
}

export const amersfoort2graden = (x, y) => {
    // amersfoortcoordinaten in meter naar WGS graden
    var graden = []
    if ((x > 1000) && (y > 1000)) {
        x = x / 1000;
        y = y / 1000;
    }
    x *= 1000;
    y *= 1000;
    var dX = (x - 155000) * Math.pow(10, -5);
    var dY = (y - 463000) * Math.pow(10, -5);
    var SomN = (3235.65389 * dY) + (-32.58297 * Math.pow(dX, 2)) + (-0.2475 * Math.pow(dY, 2)) + (-0.84978 * Math.pow(dX, 2) * dY) + (-0.0655 * Math.pow(dY, 3)) + (-0.01709 * Math.pow(dX, 2) * Math.pow(dY, 2)) + (-0.00738 * dX) + (0.0053 * Math.pow(dX, 4)) + (-0.00039 * Math.pow(dX, 2) * Math.pow(dY, 3)) + (0.00033 * Math.pow(dX, 4) * dY) + (-0.00012 * dX * dY);
    var SomE = (5260.52916 * dX) + (105.94684 * dX * dY) + (2.45656 * dX * Math.pow(dY, 2)) + (-0.81885 * Math.pow(dX, 3)) + (0.05594 * dX * Math.pow(dY, 3)) + (-0.05607 * Math.pow(dX, 3) * dY) + (0.01199 * dY) + (-0.00256 * Math.pow(dX, 3) * Math.pow(dY, 2)) + (0.00128 * dX * Math.pow(dY, 4)) + (0.00022 * Math.pow(dY, 2)) + (-0.00022 * Math.pow(dX, 2)) + (0.00026 * Math.pow(dX, 5));
    var Latitude = 52.15517 + (SomN / 3600);
    var Longitude = 5.387206 + (SomE / 3600);
    graden.push(Latitude);
    graden.push(Longitude);
    return (graden);
}

export const geometry2geoJson = (geom) => {
    var type= 'Point'
    var coordinates= []
    var str= geom.replace(/ \(/g,"(").replace(/, /g,",").replace(/ \(/g,"(")
    if (str.startsWith("POINT(")) {
        type= 'Point'
        coordinates= str.slice(6,-1).split(' ').map(value => parseFloat(value,10))
    }
    else if (str.startsWith("POLYGON((")) {
        type= 'Polygon'
        str.slice(9,-2)
            .split('),(')
            .forEach(poly => {
                const points= []
                poly.split(',').forEach(point => points.push(point.split(' ')
                    .map(value => parseFloat(value,10))
                ))
                coordinates.push(points)
            })
    }
    else if (str.startsWith("LINESTRING(")) {
        type= 'LineString'
        str.slice(11,-1).split(',')
        .forEach(point => coordinates.push(point.split(' ').map(value => parseFloat(value, 10))))
    }
    return {type, coordinates}
}

export const geometry2feature = (geom) => {
    const geo = geometry2geoJson(geom);
    var feature
    if (geo.type === 'Polygon') {
        feature = turf.centroid(turf.polygon(geo.coordinates))
    } else if (geo.type === 'LineString') {
        feature = turf.centroid(turf.lineToPolygon(turf.lineString(geo.coordinates)))
    } else {
        feature = turf.point(geo.coordinates)
    }
    return feature
}

export const location2geoJson = (location) => {
    // conversie 28992 naar 4326
    // swappen lat/lng voor polygonen
    const geo= geometry2geoJson(location.geometry)
    if (location.srid === 28992) {
        switch (geo.type) {
            case 'Point':
                geo.coordinates= amersfoort2graden(geo.coordinates[0],geo.coordinates[1])
                break
            case 'LineString':
                geo.coordinates= geo.coordinates.map(i => amersfoort2graden(i[0],i[1]))
                break
            case 'Polygon':
                geo.coordinates= geo.coordinates.map(a => a.map(i => amersfoort2graden(i[0],i[1]).reverse() ))
                break
        }
    }
    return geo
}